import React from "react";
import { MetaLabel } from "../brand/Brand";

const APP_STORE_URL = "https://apps.apple.com/us/app/bboy-creative/id6791804188";
const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.bboycreative.studio&pli=1";

const features = [
  {
    n: "01",
    t: "Explore — For you",
    d: "Scroll a curated feed of recent work. Tap any case to see the build breakdown.",
  },
  {
    n: "02",
    t: "Playground",
    d: "Try a social feed, e-commerce shop, rewards system, or booking calendar live in-app.",
  },
  {
    n: "03",
    t: "You",
    d: "Save favorite cases, bookmark features, and reach out when you're ready to start.",
  },
];

const activity = [
  { t: "Friday walkthrough", d: "Loom posted · 8 min", tag: "NEW", red: true },
  { t: "Invoice approved", d: "Milestone 02 · paid", tag: "\u2713" },
  { t: "Component library", d: "14 components shipped", tag: "" },
];

const bottomNav = [
  { i: "\u25C6", l: "Home", active: true },
  { i: "\u25C7", l: "Play" },
  { i: "\u25CE", l: "Brief" },
  { i: "\u25CB", l: "You" },
];

const PhoneMock = ({ platform = "ios" }) => {
  const isIos = platform === "ios";
  const width = 260;
  const height = 540;
  const radius = isIos ? 48 : 38;

  return (
    <div
      style={{
        width,
        height,
        background: "#000",
        borderRadius: radius,
        padding: isIos ? 8 : 6,
        position: "relative",
        boxShadow:
          "0 24px 60px rgba(0,0,0,0.5), 0 0 0 1px rgba(255,255,255,0.08)",
      }}
    >
      {isIos ? (
        <div
          style={{
            position: "absolute",
            top: 18,
            left: "50%",
            transform: "translateX(-50%)",
            width: 100,
            height: 28,
            background: "#000",
            borderRadius: 14,
            zIndex: 3,
          }}
        />
      ) : (
        <div
          style={{
            position: "absolute",
            top: 20,
            left: "50%",
            transform: "translateX(-50%)",
            width: 10,
            height: 10,
            background: "#000",
            borderRadius: "50%",
            zIndex: 3,
          }}
        />
      )}

      <div
        style={{
          width: "100%",
          height: "100%",
          background: "var(--fw-cream)",
          borderRadius: radius - (isIos ? 6 : 4),
          overflow: "hidden",
          position: "relative",
        }}
      >
        <div
          style={{
            padding: isIos ? "16px 24px 6px" : "12px 20px 6px",
            display: "flex",
            justifyContent: "space-between",
            fontFamily: isIos ? "SF Pro, Inter" : "Roboto, Inter",
            fontSize: 11,
            fontWeight: 600,
            color: "#111110",
          }}
        >
          <span>{isIos ? "9:41" : "9:41 AM"}</span>
          <span style={{ opacity: 0.7, fontSize: 10 }}>●●●● 100%</span>
        </div>

        <div style={{ padding: "24px 20px 16px" }}>
          <div
            style={{
              fontFamily: "var(--fw-mono)",
              fontSize: 8,
              letterSpacing: 1.4,
              color: "#6b655c",
              textTransform: "uppercase",
              marginBottom: 6,
            }}
          >
            ◆ PROJECT · LEDGER FIELD
          </div>
          <div
            style={{
              fontSize: 22,
              fontWeight: 800,
              color: "#111110",
              letterSpacing: -0.8,
              lineHeight: 1.05,
            }}
          >
            Week 04
            <br />
            <span style={{ color: "#c60000" }}>on schedule.</span>
          </div>
        </div>

        <div style={{ padding: "8px 20px 20px" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              fontFamily: "var(--fw-mono)",
              fontSize: 8,
              letterSpacing: 1.2,
              color: "#6b655c",
              textTransform: "uppercase",
              marginBottom: 6,
            }}
          >
            <span>DESIGN</span>
            <span>BUILD</span>
            <span>SHIP</span>
          </div>
          <div
            style={{
              height: 4,
              background: "rgba(17,17,16,0.1)",
              position: "relative",
            }}
          >
            <div
              style={{
                position: "absolute",
                left: 0,
                top: 0,
                bottom: 0,
                width: "62%",
                background: "#c60000",
              }}
            />
          </div>
          <div
            style={{
              fontFamily: "var(--fw-mono)",
              fontSize: 9,
              letterSpacing: 1,
              color: "#6b655c",
              textTransform: "uppercase",
              marginTop: 6,
            }}
          >
            62% · 2 weeks remaining
          </div>
        </div>

        <div
          style={{
            padding: "0 20px",
            display: "flex",
            flexDirection: "column",
            gap: 8,
          }}
        >
          {activity.map((item, i) => (
            <div
              key={i}
              style={{
                background: "#fff",
                padding: "12px 14px",
                borderLeft: item.red
                  ? "3px solid #c60000"
                  : "3px solid transparent",
                display: "grid",
                gridTemplateColumns: "1fr auto",
                gap: 12,
                alignItems: "center",
              }}
            >
              <div>
                <div
                  style={{
                    fontSize: 12,
                    fontWeight: 700,
                    color: "#111110",
                    letterSpacing: -0.2,
                  }}
                >
                  {item.t}
                </div>
                <div style={{ fontSize: 10, color: "#6b655c", marginTop: 2 }}>
                  {item.d}
                </div>
              </div>
              {item.tag && (
                <span
                  style={{
                    fontFamily: "var(--fw-mono)",
                    fontSize: 8,
                    letterSpacing: 1,
                    textTransform: "uppercase",
                    padding: "3px 6px",
                    background: item.red ? "#c60000" : "#111110",
                    color: "#f3efe8",
                  }}
                >
                  {item.tag}
                </span>
              )}
            </div>
          ))}
        </div>

        <div
          style={{
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            padding: isIos ? "12px 24px 28px" : "10px 20px 14px",
            background: "#fff",
            borderTop: "1px solid rgba(17,17,16,0.08)",
            display: "flex",
            justifyContent: "space-around",
          }}
        >
          {bottomNav.map((n, i) => (
            <div
              key={i}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 2,
              }}
            >
              <span
                style={{
                  fontSize: 14,
                  color: n.active ? "#c60000" : "#6b655c",
                }}
              >
                {n.i}
              </span>
              <span
                style={{
                  fontFamily: "var(--fw-mono)",
                  fontSize: 7,
                  letterSpacing: 1,
                  textTransform: "uppercase",
                  color: n.active ? "#111110" : "#6b655c",
                  fontWeight: n.active ? 700 : 400,
                }}
              >
                {n.l}
              </span>
            </div>
          ))}
        </div>

        {isIos && (
          <div
            style={{
              position: "absolute",
              bottom: 8,
              left: "50%",
              transform: "translateX(-50%)",
              width: 120,
              height: 4,
              background: "#111110",
              borderRadius: 2,
            }}
          />
        )}
      </div>
    </div>
  );
};

const storeBadgeStyle = {
  marginTop: 12,
  display: "inline-flex",
  alignItems: "center",
  gap: 10,
  background: "var(--fw-cream)",
  color: "var(--fw-ink)",
  padding: "12px 20px",
  textDecoration: "none",
  fontFamily: "var(--fw-mono)",
  fontSize: 11,
  letterSpacing: "1.4px",
  textTransform: "uppercase",
  fontWeight: 500,
};


const AppsShowcase = () => (
  <section
    id="apps"
    style={{
      padding: "80px 40px",
      background: "var(--fw-ink)",
      color: "var(--fw-cream)",
      position: "relative",
    }}
    className="fw-apps"
  >
    <div style={{ maxWidth: 1440, margin: "0 auto" }}>
      <div className="fw-apps__head">
        <div>
          <MetaLabel color="var(--fw-muted-2)">In your pocket</MetaLabel>
          <h2
            style={{
              fontSize: 48,
              letterSpacing: -1.8,
              lineHeight: 1,
              margin: "12px 0 0",
              fontWeight: 800,
              color: "var(--fw-cream)",
            }}
          >
            Explore<span style={{ color: "var(--fw-red)" }}>.</span>
            <br />
            <span style={{ fontStyle: "italic" }}>Play. Ship.</span>
          </h2>
        </div>
        <div
          style={{
            fontSize: 18,
            lineHeight: 1.55,
            color: "var(--fw-cream)",
            maxWidth: 640,
            paddingTop: 28,
          }}
        >
          A native iOS and Android app for founders browsing what we've built.
          Scroll a feed of case studies, play with real working features, and
          save the ones you want for your own product.
        </div>
      </div>

      <div className="fw-apps__showcase">
        <div className="fw-apps__phone">
          <PhoneMock platform="ios" />
          <div style={{ textAlign: "center" }}>
            <MetaLabel color="var(--fw-muted-2)">◇ iOS · 17+</MetaLabel>
            <a href={APP_STORE_URL} style={storeBadgeStyle}>
              <span style={{ fontSize: 18 }}>◆</span> App Store
            </a>
          </div>
        </div>

        <div className="fw-apps__features">
          {features.map((f) => (
            <div
              key={f.n}
              style={{
                display: "grid",
                gridTemplateColumns: "40px 1fr",
                gap: 20,
                paddingBottom: 20,
                borderBottom: "1px solid rgba(255,255,255,0.1)",
              }}
            >
              <div
                style={{
                  fontFamily: "var(--fw-mono)",
                  fontSize: 11,
                  letterSpacing: "1.4px",
                  color: "var(--fw-red)",
                  paddingTop: 2,
                }}
              >
                {f.n}
              </div>
              <div>
                <div
                  style={{
                    fontSize: 17,
                    fontWeight: 700,
                    letterSpacing: -0.3,
                    marginBottom: 4,
                  }}
                >
                  {f.t}
                </div>
                <div
                  style={{
                    fontSize: 13,
                    lineHeight: 1.5,
                    color: "var(--fw-muted-2)",
                  }}
                >
                  {f.d}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="fw-apps__phone">
          <PhoneMock platform="android" />
          <div style={{ textAlign: "center" }}>
            <MetaLabel color="var(--fw-muted-2)">◈ ANDROID · 13+</MetaLabel>
            <a href={PLAY_STORE_URL} style={storeBadgeStyle}>
              <span style={{ fontSize: 18 }}>▶</span> Play Store
            </a>
          </div>
        </div>
      </div>
    </div>

    <style>{`
      .fw-apps__head {
        display: grid;
        grid-template-columns: 280px 1fr;
        gap: 80px;
        margin-bottom: 64px;
      }
      .fw-apps__showcase {
        display: grid;
        grid-template-columns: 1fr 1.2fr 1fr;
        gap: 40px;
        align-items: center;
        margin-bottom: 64px;
      }
      .fw-apps__phone {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 24px;
      }
      .fw-apps__features {
        display: flex;
        flex-direction: column;
        gap: 24px;
        padding: 0 20px;
      }
      @media (max-width: 960px) {
        .fw-apps__head {
          grid-template-columns: 1fr;
          gap: 24px;
          margin-bottom: 48px;
        }
        .fw-apps__showcase {
          grid-template-columns: 1fr;
          gap: 48px;
        }
        .fw-apps__features { padding: 0; }
      }
    `}</style>
  </section>
);

export default AppsShowcase;
